export default __webpack_public_path__ + "static/media/shuffle.a66d2303.svg";